const PartnersDatas = [
    {
      link: 'https://www.gfteamofficial.com/',
      image: require('../img/gft.jpg'),
      alt: "Grappling Fight Team",
      title: "Grappling Fight Team"
    },
    {
      link: 'https://www.blrjj.com/',
      image: require('../img/blr.jpg'),
      alt: "B.L.R Jiu Jitsu",
      title: "B.L.R Jiu Jitsu"
    },
    {
      link: 'https://builtbykids.fr/',
      image: require('../img/builtbykids.jpg'),
      alt: "Built By Kids JJB",
      title: "Built By Kids JJB"
    }
  ]
export default PartnersDatas;